import React, { useEffect, useRef, useState, useMemo } from "react";
import { Helmet } from "react-helmet";

import { MainContainer } from "./styles";

/* eslint-disable */
const SimplexBuy = () => {
  const bodyRef = useRef(null);
  const documentGlobal = typeof document !== "undefined" && document;
  const windowGlobal = typeof window !== "undefined" && window;

  const formScriptElement = useMemo(() => {
    if (!documentGlobal) {
      return;
    }
    const scriptElement = documentGlobal.createElement("script");
    scriptElement.src = "https://iframe.simplex-affiliates.com/form-sdk.js";
    scriptElement.type = "text/javascript";
    return scriptElement;
  }, []);

  if (windowGlobal) {
    windowGlobal.simplex = {};
  }

  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (bodyRef.current !== null && !hasLoaded && windowGlobal) {
      bodyRef.current.appendChild(formScriptElement);
      if (windowGlobal.simplex) {
        setTimeout(() => windowGlobal.simplex.createForm(), 2000);
      }
      setHasLoaded(true);
    }

    return () => {
      formScriptElement.remove();
    };
  }, [bodyRef.current]);

  return (
    <>
      <Helmet>
        <meta name="referrer" content="strict-origin-when-cross-origin" />
        <script>
            {`window.simplexAsyncFunction = function () {
                Simplex.init({
                  public_key: "pk_live_7416cee8-18f5-4c4a-bedc-53cd536cff1b",
                });
              }`}
          </script>
          <script src="https://cdn.simplex.com/sdk/v1/js/sdk.js" async></script>
          <script src="https://checkout.simplexcc.com/splx.js"></script>
          <style id="simplex-css">
            {`
             @media screen and (max-width: 900px) {
              .fiat {
                margin-left: 0px !important;
                max-width: 100% !important;
              }
              .crypto {
                margin-left: 0px !important;
                max-width: 100% !important;
              }
            }
          .simplex-form {
            color: #FFF;
          }
          .crypto-address{
            margin: 0px;
          }
          
          .simplex-dd-container {
            display: flex;
            flex-direction: column;
          }
          
          .fiat {
            margin-left: 8.3333%;
            max-width: 83.2%;
          }
          
          .crypto {
            max-width: 83.2%;
          }
          
          #crypto_amount,
          #fiat_amount,
          #cryptoAddress {
            border: 1px solid #3E4352;
            background: transparent;
            color: white;
            border-radius: 6px;
            display: block;
            height: 50px;
          }
          
          .crypto-dd,
          .fiat-dd {
            border: 1px solid #3E4352;
            color: white;
            background-color: rgba(0, 0, 0, 0);
            height: 50px;
            margin-left: 10px;
            border-radius: 6px;
          }
          
          .border-light {
            border-color: #3E4352 !important;
          }
          
          .crypto-dd + ul,
          .fiat-dd + ul {
            color: white;
            background-color: #3E4352;
          }
          
          .walletconnect-link,
          .wallet-url {
            color: #2E73FA !important;
          }
          
          .tooltip-container inputFields input-group {
            border: 10px solid #3E4352;
          }
          
          .simplex-continue-button {
            border-radius: 100px;
            background-color: #1552EF;
            border: none;
            color: #FFF;
            margin-bottom: 30px;
          }
          
          .crypto-dd + ul > li:hover,
          .fiat-dd + ul > li:hover {
            background-color: #2E73FA;
            color: #FFF;
          }
          
          .powered-logo img{
            -webkit-filter: invert(1);
            filter: invert(1);
          }`}
          </style>
      </Helmet>
      <MainContainer ref={bodyRef}>
        <form id="simplex-form">
          <div id="checkout-element"></div>
        </form>
      </MainContainer>
    </>
  );
};

export default SimplexBuy;
